import React, { useState } from "react"
import { Link } from "react-router-dom"

import { Anchor, Text } from "@mantine/core"
import { showNotification, updateNotification } from "@mantine/notifications"
import { IconCheck, IconX } from "@tabler/icons-react"
import { FirestoreError } from "firebase/firestore"
import { useLanguage } from "../contexts/language-context"

export const useCloudFunction = (name: string) => {
    const [processing, setProcessing] = useState(false)
    const { L } = useLanguage()

    const id = `${name}-${Math.floor(Math.random() * 16 ** 6).toString(16)}`

    const onStart = (title: string, message = L("Your changes are being saved. This won't take long.")) => {
        setProcessing(true)
        showNotification({
            id,
            title,
            message,
            loading: true,
            autoClose: false,
            withCloseButton: false,
        })
    }

    const onSuccess =
        (title = L("Update successful!"), message = L("Your changes were saved successfully.")) =>
        () => {
            setProcessing(false)
            updateNotification({
                id,
                title,
                message,
                color: "teal",
                icon: <IconCheck size={18} />,
                autoClose: 2000,
            })
        }

    const onError =
        (title = L("Update failed!"), message?: string) =>
        (error: FirestoreError) => {
            setProcessing(false)
            updateNotification({
                id,
                title,
                message: (
                    <Text color="dimmed">
                        {message}
                        {message && <br />}
                        {L(
                            "If this error persists, please contact %s.",
                            <Anchor component={Link} to="mailto:dev@ecomoni.nl">
                                {L("Ecomoni support")}
                            </Anchor>,
                        )}
                        <br />
                        <i>{error.message}</i>
                    </Text>
                ),
                color: "red",
                icon: <IconX size={18} />,
                autoClose: 2000,
            })
            console.error(error)
        }

    return {
        onStart,
        onSuccess,
        onError,
        processing,
    }
}
